const DISPLAY_DURATION = 6000;
const TRANSITION_DURATION = 1000;

document.querySelectorAll('[data-logo-taglines]').forEach((tagline) => {
  const taglines = JSON.parse(tagline.dataset.logoTaglines);
  let currentIndex = taglines.indexOf(tagline.textContent);

  if (taglines.length < 2 || currentIndex === -1) {
    return;
  }

  window.setInterval(() => {
    tagline.classList.add('is-changing');

    window.setTimeout(() => {
      currentIndex = (currentIndex + 1) % taglines.length;
      tagline.textContent = taglines[currentIndex];
      tagline.classList.remove('is-changing');
    }, TRANSITION_DURATION);
  }, DISPLAY_DURATION);
});
